import i18n from '@/plugins/i18n';

export default function (program_code) {
    let options = [
        {
            value: "jazz",
            text: i18n.t('jazz'),
            program_code: ['11022101']
        },
        {
            value: "turkish_music",
            text: i18n.t('turkish_music'),
            program_code: ['11022101']
        },
        {
            value: "classic_music",
            text: i18n.t('classic_music'),
            program_code:['11022101']
        },
        {
            value: "jazz_vocal",
            text: i18n.t('jazz_vocal'),
            program_code: ['11022101']

        },
        {
            value: "composition_arrangement",
            text: i18n.t('composition_arrangement'),
            program_code: ['11022101']

        },
        {
            value: "music_teories",
            text: i18n.t('music_teories'),
            program_code: ['11022101']

        },
        {
            value: "classical_turkish_music",
            text: i18n.t('classical_turkish_music'),
            program_code: ['11042101']
        },
        {
            value: "turkish_folk_music",
            text: i18n.t('turkish_folk_music'),
            program_code: ['11042101']
        },
        {
            value: "popular_music_singing",
            text: i18n.t('popular_music_singing'),
            program_code: ['11042101']
        },
        {
            value: "opera_and_choir_singing",
            text: i18n.t('opera_and_choir_singing'),
            program_code: ['11042101']
        },


    ]

    return options.filter(option => option.program_code.includes(program_code));
}


